import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/en";

import isBetween from "dayjs/plugin/isBetween";
import { PercentageCalculator } from "./PercentageCalculator";
import { Forecast } from "./Forecast";
import { Graphs } from "./Graphs";
import { cmToInches } from "../../../utils/cmToInchesConversion";

dayjs.extend(isBetween);

const { RangePicker } = DatePicker;

const HeadSizeDashboardContent = ({
  currentOrg,
  currentSite,
  graphData,
  dateList,
  siteMetadata,
  currentCrop,
  currentGreenhouse,
  currentPlot,
  currentDate,
}) => {
  const isImperial = currentSite?.metadata?.siteConfig?.display_units === "imperial";
  const BIN_START = 0;
  const BIN_END = isImperial ? Math.ceil(cmToInches(25)) * 2 : 24;
  const DISPLAY_MAX = isImperial ? Number((25 / 2.5).toFixed(2)) : 23;

  const [minSize, setMinSize] = useState(BIN_START);
  const [maxSize, setMaxSize] = useState(DISPLAY_MAX);
  const [filteredGraphData, setFilteredGraphData] = useState([]);

  const [showPercentage, setShowPercentage] = useState(false);
  const [averageData, setAverageData] = useState([]);

  useEffect(() => {
    setMinSize(BIN_START);
    setMaxSize(DISPLAY_MAX);
  }, [DISPLAY_MAX]);

  return (
    <>
      <div className="flex lg:flex-col flex-row w-full mb-4">
        <div className="headsize-section w-full flex flex-col items-center lg:justify-center justify-start px-10 sm:px-4 py-4 lg:mr-0 mr-4 lg:mb-4 rounded-md shadow-md hover:shadow-2xl transition-shadow duration-300 transform hover:scale-101">
          {/* Percentage Calculator Section */}
          <PercentageCalculator
            siteMetadata={siteMetadata}
            currentCrop={currentCrop}
            currentGreenhouse={currentGreenhouse}
            currentPlot={currentPlot}
            minSize={minSize}
            maxSize={maxSize}
            setMaxSize={setMaxSize}
            setMinSize={setMinSize}
            setShowPercentage={setShowPercentage}
            showPercentage={showPercentage}
            filteredGraphData={filteredGraphData}
            isImperial={isImperial}
          />
        </div>
        <div className="headsize-section w-full flex flex-col items-center justify-center px-10 py-4 sm:px-4 rounded-md shadow-md hover:shadow-2xl transition-shadow duration-300 transform hover:scale-100">
          {/* Broccoli Head Count Forecast Card */}
          <Forecast
            currentSite={currentSite}
            siteMetadata={siteMetadata}
            currentCrop={currentCrop}
            currentGreenhouse={currentGreenhouse}
            currentPlot={currentPlot}
            isImperial={isImperial}
            averageData={averageData}
          />
        </div>
      </div>

      {/* Graph Section */}
      <Graphs
        BIN_END={BIN_END}
        isImperial={isImperial}
        currentOrg={currentOrg}
        currentSite={currentSite}
        currentCrop={currentCrop}
        currentGreenhouse={currentGreenhouse}
        currentPlot={currentPlot}
        currentDate={currentDate}
        graphData={graphData}
        dateList={dateList}
        siteMetadata={siteMetadata}
        minSize={minSize}
        maxSize={maxSize}
        showPercentage={showPercentage}
        setShowPercentage={setShowPercentage}
        filteredGraphData={filteredGraphData}
        setFilteredGraphData={setFilteredGraphData}
        setAverageData={setAverageData}
        averageData={averageData}
      ></Graphs>
    </>
  );
};

export default HeadSizeDashboardContent;
